import { useEffect } from 'react'
import { Platform } from 'react-native'

export function useDismissOnEscape(visible: boolean, onDismiss: () => void) {
    useEffect(() => {
        if (!visible || Platform.OS !== 'web') return
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onDismiss()
        }
        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [visible, onDismiss])
}
